import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class PrimengCalendarLocaleService {
  constructor(
    private translate: TranslateService,
    private primengConfig: PrimeNGConfig
  ) {
    // Automatically update locale when language changes
    this.translate.onLangChange.subscribe(() => {
      this.setLocale(this.getCalendarLocale());
    });
  }

  /** Builds the calendar locale object from translation keys */
  getCalendarLocale() {
    return {
      firstDayOfWeek: 1,
      dayNames: [
        this.translate.instant('PN_SUNDAY'),
        this.translate.instant('PN_MONDAY'),
        this.translate.instant('PN_TUESDAY'),
        this.translate.instant('PN_WEDNESDAY'),
        this.translate.instant('PN_THURSDAY'),
        this.translate.instant('PN_FRIDAY'),
        this.translate.instant('PN_SATURDAY'),
      ],
      dayNamesShort: [
        this.translate.instant('PN_SHORT_SUN'),
        this.translate.instant('PN_SHORT_MON'),
        this.translate.instant('PN_SHORT_TUE'),
        this.translate.instant('PN_SHORT_WED'),
        this.translate.instant('PN_SHORT_THU'),
        this.translate.instant('PN_SHORT_FRI'),
        this.translate.instant('PN_SHORT_SAT'),
      ],
      dayNamesMin: [
        this.translate.instant('PN_MIN_SU'),
        this.translate.instant('PN_MIN_MO'),
        this.translate.instant('PN_MIN_TU'),
        this.translate.instant('PN_MIN_WE'),
        this.translate.instant('PN_MIN_TH'),
        this.translate.instant('PN_MIN_FR'),
        this.translate.instant('PN_MIN_SA'),
      ],
      monthNames: [
        this.translate.instant('PN_JANUARY'),
        this.translate.instant('PN_FEBRUARY'),
        this.translate.instant('PN_MARCH'),
        this.translate.instant('PN_APRIL'),
        this.translate.instant('PN_MAY'),
        this.translate.instant('PN_JUNE'),
        this.translate.instant('PN_JULY'),
        this.translate.instant('PN_AUGUST'),
        this.translate.instant('PN_SEPTEMBER'),
        this.translate.instant('PN_OCTOBER'),
        this.translate.instant('PN_NOVEMBER'),
        this.translate.instant('PN_DECEMBER'),
      ],
      monthNamesShort: [
        this.translate.instant('PN_SHORT_JAN'),
        this.translate.instant('PN_SHORT_FEB'),
        this.translate.instant('PN_SHORT_MAR'),
        this.translate.instant('PN_SHORT_APR'),
        this.translate.instant('PN_SHORT_MAY'),
        this.translate.instant('PN_SHORT_JUN'),
        this.translate.instant('PN_SHORT_JUL'),
        this.translate.instant('PN_SHORT_AUG'),
        this.translate.instant('PN_SHORT_SEP'),
        this.translate.instant('PN_SHORT_OCT'),
        this.translate.instant('PN_SHORT_NOV'),
        this.translate.instant('PN_SHORT_DEC'),
      ],
      today: this.translate.instant('TODAY'),
      clear: this.translate.instant('CLEAR'),
    };
  }

  /** Applies the given locale to PrimeNG globally */
  setLocale(locale: any) {
    this.primengConfig.setTranslation(locale);
  }

  /** Initializes locale (call once after app startup) */
  init() {
    this.setLocale(this.getCalendarLocale());
  }
}
